import VueCookies from 'vue-cookies';
import request from '@/helpers/request';

const initState = {
  shouldDisplay: false,
  isVisible: false,
  product: {
    name: '',
    variation: '',
    imageSrc: '',
    altText: '',
  },
  compatibleAccessories: {},
  compatibleAccessoriesPrices: {},
};

export default {
  state: { ...initState },
  getters: {
    getInterstitialShouldDisplay(state) {
      return state.shouldDisplay;
    },
    getInterstitialIsVisible(state) {
      return state.isVisible;
    },
    getInterstitialProductDetails(state) {
      return state.product;
    },
    getInterstitialProductDescription(state) {
      return `${state.product.name} - ${state.product.variation}`;
    },
    getInterstitialProductImage(state) {
      return state.product.imageSrc;
    },
    getInterstitialProductAltText(state) {
      return state.product.altText;
    },
    getInterstitialAccessories(state) {
      return (partNumber) => state.compatibleAccessories[partNumber];
    },
    getHasInterstitialAccessories(state, getters) {
      const partNumber = getters.getPartNumber;
      const items = getters.getInterstitialAccessories(partNumber) || [];
      return !!items.length;
    },
    getInterstitialAccessoryPrices(state) {
      return state.compatibleAccessoriesPrices;
    },
    getInterstitialAccessoryPriceByUrl(state, getters) {
      return (priceUrl) => getters.getInterstitialAccessoryPrices[priceUrl];
    },
  },
  mutations: {
    resetInterstitial(state) {
      state.shouldDisplay = initState.shouldDisplay;
      state.isVisible = initState.isVisible;
      state.product = { ...initState.product };
    },
    setInterstitialShouldDisplay(state, payload) {
      state.shouldDisplay = payload;
    },
    setInterstitialIsVisible(state, payload) {
      state.isVisible = payload;
    },
    setInterstitialProductDetails(state, payload) {
      state.product = payload;
    },
    setInterstitialAccessory(state, payload) {
      const { partNumber, data } = payload;
      const accessories = state.compatibleAccessories[partNumber];

      state.compatibleAccessories[partNumber] = accessories.map((item) => {
        if (item.partNumber === data.partNumber) {
          return data;
        }
        return item;
      });
    },
    setInterstitialAccessories(state, payload) {
      const { data, partNumber } = payload;
      state.compatibleAccessories = { ...state.compatibleAccessories, [partNumber]: data };
    },
    setInterstitialAccessoryPrice(state, payload) {
      const { data, priceUrl } = payload;
      state.compatibleAccessoriesPrices = {
        ...state.compatibleAccessoriesPrices,
        [priceUrl]: data,
      };
    },
  },
  actions: {
    resetInterstitial({ commit }) {
      commit('resetInterstitial');
    },
    setInterstitialShouldDisplay({ commit }, payload) {
      commit('setInterstitialShouldDisplay', payload);
    },
    setInterstitialIsVisible({ commit }, payload) {
      commit('setInterstitialIsVisible', payload);
    },
    setInterstitialProductDetails({ commit }, payload) {
      commit('setInterstitialProductDetails', payload);
    },
    async callInterstitialAccessories({ commit, getters }) {
      const {
        getBuyGarminEndpoint, getLocale, getStoreCode,
        getProductId, getPartNumber, getProductPageApi,
      } = getters;

      const url = `${getProductPageApi}/${getProductId}/compatibleProducts`;
      let accessories = getters.getInterstitialAccessories(getPartNumber);

      if (!accessories) {
        accessories = await request({ url });

        // Commit the accessories after fetching
        commit('setInterstitialAccessories', {
          partNumber: getPartNumber,
          data: accessories,
        });
      }

      // Cookie accessible only on garmin domain
      const cookie = VueCookies.get('GarminBuyCacheKey');
      const customerGroup = cookie || 'none';

      // Continue to get the prices
      accessories.forEach(async (item) => {
        const priceUrl = `${getBuyGarminEndpoint}/${getLocale}/${getStoreCode}/price/sku/${item.partNumber}.json?cg=${customerGroup}`;
        const cachedPrice = getters.getInterstitialAccessoryPriceByUrl(priceUrl);

        const itemPrice = cachedPrice || await request({ url: priceUrl }).catch(() => {});

        const newPrice = {
          data: itemPrice,
          priceUrl,
        };

        // Add the price to the accessory
        item.priceObj = itemPrice || {};

        // Commit the accessory again with the price updated
        commit('setInterstitialAccessory', {
          partNumber: getPartNumber,
          data: item,
        });

        // Cache accessory price
        commit('setInterstitialAccessoryPrice', newPrice);
      });
    },
  },
};
